import { styled } from '@mui/material/styles'

const Col = styled('div')(({ padding }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: padding || 'inherit',
}))

export default Col
